export default {"src":"/_next/static/media/0xddafbb505ad214d7b80b1f830fccc89b60fb7a83.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};